export enum Locales {
  NL = 'nl',
  EN = 'en',
}

export const LOCALES = [
  { value: Locales.NL, caption: 'Dutch' },
  { value: Locales.EN, caption: 'English' },
];
